// Icons for StatBoxes
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import TodayIcon from "@mui/icons-material/Today";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
export const tabConfig = [
  {
    id: "active",
    label: "Active",
    activeColor: "#D92906",
  },
  {
    id: "pending",
    label: "To Accept",
    activeColor: "#ed6c02",
  },
  {
    id: "acknowledge",
    label: "To Acknowledge",
    activeColor: "#0288d1",
  },
  {
    id: "assigned",
    label: "Assigned By Me",
    activeColor: "#2e7d32",
  },
];

export const statBoxConfig = [
  {
    id: "overdue",
    count: 1,
    label: "Past Deadline",
    icon: <ErrorOutlineIcon />,
    color: "#D92906",
  },
  {
    id: "dueToday",
    count: 1,
    label: "Due Today",
    icon: <TodayIcon />,
    color: "#ed6c02",
  },
  {
    id: "pending",
    count: 1,
    label: "To Accept",
    icon: <HourglassEmptyIcon />,
    color: "#0288d1",
  },
  {
    id: "acknowledge",
    count: 2,
    label: "To Acknowledge",
    icon: <PlaylistAddCheckIcon />,
    color: "#9c27b0",
  },
];
